import { LAYOUTS } from "@voltmoney/types";
import SharedPropsService from "../../../SharedPropsService";
import { ROUTE } from "../../../routes";
import { WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { clearDues, forecloseAccount, goBack, navigateToDashboard, releaseCollateral, storeUserFeedback } from "./action";
import { getContactUsDetails } from "../../../configs/utils";
export const template = (height, contactUsDetails, collateralStepperData, mutualFundStepperData, loanStepperData, prepayStepperData) => ({
    layout: {
        id: ROUTE.FORECLOSURE_REASON,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: "foreclosureReason",
                type: WIDGET.FORECLOSURE_REASON_SCREEN,
            },
        ],
    },
    datastore: {
        foreclosureReason: {
            height,
            contactUsDetails,
            collateralStepperData,
            mutualFundStepperData,
            loanStepperData,
            prepayStepperData,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.FORECLOSURE_REASON,
            },
            releaseCollateralAction: {
                type: ACTION.RELEASE_COLLATERAL,
                routeId: ROUTE.FORECLOSURE_REASON,
            },
            navigateToDashboardAction: {
                type: ACTION.NAVIGATE_TO_DASHBOARD,
                routeId: ROUTE.FORECLOSURE_REASON,
            },
            closeAccountAction: {
                type: ACTION.CLOSE_ACCOUNT,
                routeId: ROUTE.FORECLOSURE_REASON,
            },
            clearDuesAction: {
                type: ACTION.CLEAR_DUES,
                routeId: ROUTE.FORECLOSURE_REASON,
            },
            feedbackStoreAction: {
                type: ACTION.STORE_FEEDBACK,
                routeId: ROUTE.FORECLOSURE_REASON,
                payload: {},
            }
        },
    },
});
export const foreclosureReasonScreenMf = {
    onLoad: async ({ instrumentTrack, getHeight }, {}) => {
        const user = await SharedPropsService.getUser();
        const contactUsDetails = await getContactUsDetails();
        let creditAmount = user.linkedCredits[0].actualLoanAmount;
        let totalOutstanding = user.linkedCredits[0].totalValueOfAssetsPledged;
        await SharedPropsService.setTotalCreditAmount(creditAmount);
        await SharedPropsService.setTotalFundAmount(totalOutstanding);
        const collateralStepperData = [
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Your assets, your ownership",
                "verticalDescription": `Your assets remain in your name and continue to earn market returns.`,
                "order": 0
            },
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Increase your credit limit in just 5 min",
                "verticalDescription": `Add more collateral anytime to expand your borrowing capacity.`,
                "order": 1
            },
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Easy collateral release",
                "verticalDescription": `Free up your pledged assets partially or fully after clearing the outstanding balance.`,
                "order": 2
            },
        ];
        const mutualFundStepperData = [
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Pay only for what you use",
                "verticalDescription": `Zero charges when not using the credit line - interest applies only on used amount.`,
                "order": 0
            },
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Save on capital gains tax",
                "verticalDescription": `Avoid STCG & LTCG by keeping investments while accessing funds at lower borrowing costs.`,
                "order": 1
            },
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Maximize investment returns",
                "verticalDescription": `Let your investments grow in the market while having ready access to funds.`,
                "order": 2
            },
        ];
        const loanStepperData = [
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Instant access to cash",
                "verticalDescription": `Get the funds you need, when you need them, for any emergency or opportunity.`,
                "order": 0
            },
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Control over repayment",
                "verticalDescription": `Pay back what you borrow on a schedule that fits your needs.`,
                "order": 1
            },
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Easy collateral management",
                "verticalDescription": `Quickly add or remove collateral to adjust your credit limit.`,
                "order": 2
            },
        ];
        const prepayStepperData = [
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Pay interest only on what you use",
                "verticalDescription": `Interest is calculated daily on your utilized amount, unlike traditional loans.`,
                "order": 0
            },
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Freedom of principal repayment",
                "verticalDescription": `No fixed repayment schedule - pay principal at your convenience.`,
                "order": 1
            },
            {
                "status": "NOT_STARTED",
                "verticalDisplayName": "Strengthen your credit score",
                "verticalDescription": `Maintaining your credit line account will help you  boost your credit score.`,
                "order": 2
            },
        ];
        return Promise.resolve(template(getHeight(), contactUsDetails, collateralStepperData, mutualFundStepperData, loanStepperData, prepayStepperData));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.RELEASE_COLLATERAL]: releaseCollateral,
        [ACTION.NAVIGATE_TO_DASHBOARD]: navigateToDashboard,
        [ACTION.CLOSE_ACCOUNT]: forecloseAccount,
        [ACTION.CLEAR_DUES]: clearDues,
        [ACTION.STORE_FEEDBACK]: storeUserFeedback,
    },
};
